import { LicenseInfo } from "@mui/x-license-pro";

export const applyLicenseKey = () => {
  LicenseInfo.setLicenseKey(
    "74c3b9c03880c75b0883807cc9f17463Tz05OTMwMCxFPTE3NTk1NTk4NjAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg=="
  );
};